import store from '@/store';
import client from './apiCommonConnector';

export default {
  async createUserAccess(userId) {
    try {
      await client().post(`/users/${userId}/idp`);
      await client().post(`/users/${userId}/initialize-password`);
      return true;
    } catch (e) {
      if (e.response.data === 'email.in_use') {
        store.dispatch('errorHandler/throwError', {
          title: "Echec de la création de l'accès",
          detail: 'Cette addresse mail est déja affectée à un accès STUDIO.',
        });
      } else {
        store.dispatch('errorHandler/throwError', {
          title: "Echec de la création de l'accès",
          detail: "Une erreur s'est produite lors de la création de l'accès Studio de l'utilisateur, veuillez réessayer.",
        });
      }
      return false;
    }
  },

  async createContactAccess(contactId) {
    try {
      await client().post(`/ambassador/contacts/${contactId}/idp`);
      await client().post(`/ambassador/contacts/${contactId}/initialize-password`);
      return true;
    } catch (e) {
      if (e.response.data === 'email.in_use') {
        store.dispatch('errorHandler/throwError', {
          title: "Echec de la création de l'accès",
          detail: 'Cette addresse mail est déja affectée à un accès STUDIO.',
        });
      } else {
        store.dispatch('errorHandler/throwError', {
          title: "Echec de la création de l'accès",
          detail: "Une erreur s'est produite lors de la création de l'accès Studio du contact, veuillez réessayer.",
        });
      }
      return false;
    }
  },

  async resendUserSetPasswordEmail(userId) {
    try {
      await client().post(`/users/${userId}/initialize-password`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'envoi du mail de relance",
        detail: "Une erreur s'est produite lors de l'envoi du mail de relance pour l'initialisation du mot de passe Studio, veuillez réessayer.",
      });
      return false;
    }
  },

  async resendContactSetPasswordEmail(contactId) {
    try {
      await client().post(`/ambassador/contacts/${contactId}/initialize-password`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'envoi du mail",
        detail: "Une erreur s'est produite lors de l'envoi du mail de relance pour l'initialisation du mot de passe Studio, veuillez réessayer.",
      });
      return false;
    }
  },

  async resetUserPassword(userId) {
    try {
      await client().post(`/users/${userId}/reset-password`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'envoi du mail",
        detail: "Une erreur s'est produite lors de l'envoi du mail de la réinitialisation du mot de passe Studio, veuillez réessayer.",
      });
      return false;
    }
  },

  async resetContactPassword(contactId) {
    try {
      await client().post(`/ambassador/contacts/${contactId}/reset-password`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'envoi du mail",
        detail: "Une erreur s'est produite lors de l'envoi du mail de la réinitialisation du mot de passe Studio, veuillez réessayer.",
      });
      return false;
    }
  },

  async setUserNewAccessRoles(userId, toRemoveIds) {
    try {
      if (toRemoveIds.length) {
        await client().delete(`/users/${userId}/roles/${toRemoveIds[0]}`);
        if (toRemoveIds.length > 1) {
          await Promise.all(toRemoveIds.slice(1).map(roleId => client().delete(`/users/${userId}/roles/${roleId}`)));
        }
      }
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'affectation des rôles",
        detail: "Une erreur s'est produite lors de l'édition des rôles du nouvel accès Studio, veuillez réessayer.",
      });
    }
  },

  async setContactNewAccessRoles(contactId, toRemoveIds) {
    try {
      if (toRemoveIds.length) {
        await client().delete(`/ambassador/contacts/${contactId}/roles/${toRemoveIds[0]}`);
        if (toRemoveIds.length > 1) {
          await Promise.all(toRemoveIds.slice(1).map(roleId => client().delete(`/ambassador/contacts/${contactId}/roles/${roleId}`)));
        }
      }
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'affectation des rôles",
        detail: "Une erreur s'est produite lors de l'édition des rôles du nouvel accès Studio, veuillez réessayer.",
      });
    }
  },
};
